import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseStages = async () => {
  return await request.get(
    `/FlatsGrid/house_stages`,
    {},
    'При загрузке возможных состояний дома произошла ошибка',
    []
  );
};

const useHouseStages = (options) =>
  useQuery(getQueryKeys.houseStages(), getHouseStages, options);

export default useHouseStages;
